import React from 'react'
import {Link} from 'react-router-dom'
import {withTranslation} from 'react-i18next'
import GoogleLogin from 'react-google-login';
import {Divider} from 'antd'

import {usersService} from 'services'
import requestHandler from 'utils/requestHandler'
import {logInUser} from 'utils/user'
import useUserContext from 'components/User/useUserContext'
import FormHandler from 'components/Form/FormHandler'
import BInput from 'components/Form/Fields/BInput'

const LoginForm = ({history}) => {
  const {setUser} = useUserContext()

  const submitCallback = (values, setLoading) => {
    requestHandler(() => usersService.authEmail(values), 'json')
      .then(response => {
        logInUser(response, setUser, setLoading)
        if (response.success) history.push('/profile')
      })
  }

  return (
    <FormHandler submitCallback={submitCallback} submitTitle='Log in'>
      <BInput
        fieldName='email' icon='mail' label='Email'
        rules={[
          {required: true, message: 'Please input your Email'},
          {type: 'email', message: 'The input is not valid Email'},
        ]}/>
      <BInput
        fieldName='password' icon='key' label='Password' password
        rules={[{required: true, message: 'Please input your password'}]}/>
    </FormHandler>
  )
}

const GoogleLoginBtn = ({history, t}) => {
  const {setUser} = useUserContext()

  const onSuccess = r => {
    requestHandler(() => usersService.authGoogle({googleAccessToken: r.tokenObj.id_token}), 'json')
      .then(response => {
        logInUser(response, setUser)
        if (response.success) history.push('/profile')
      })
  }

  const onFailure = (response) => {
    console.log(response);
  }

  return (
    <div className='googleLogin'>
      <GoogleLogin
        clientId="827495843132-c1q800s1ifc445ret7fhqs6fnijbfh3j.apps.googleusercontent.com"
        buttonText={t('Login with Google')}
        onSuccess={onSuccess}
        onFailure={onFailure}
        cookiePolicy={'single_host_origin'}
      />
    </div>
  )
}

const Login = ({t, history}) => (
  <div className='loginMain basicForm'>
    <LoginForm history={history}/>
    <Link to='/register'>{t('Register')}</Link>
    <Divider>{t('or')}</Divider>
    <GoogleLoginBtn history={history} t={t}/>
  </div>
)

export default withTranslation()(Login)
